// Función para obtener la fecha de publicación por defecto
export function getDefaultPublishDate() {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(9, 0, 0, 0);

  const dayOfWeek = tomorrow.getDay();

  // Si es sábado (6), agregar 2 días para llegar a lunes
  if (dayOfWeek === 6) {
    tomorrow.setDate(tomorrow.getDate() + 2);
  }
  // Si es domingo (0), agregar 1 día para llegar a lunes
  else if (dayOfWeek === 0) {
    tomorrow.setDate(tomorrow.getDate() + 1);
  }

  return tomorrow;
}

// Función para formatear fecha a texto legible
export function getDateFormatText(dateString) {
  if (!dateString) return '';

  try {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('es-ES', options);
  } catch {
    return dateString;
  }
}
